import {

    CREATE_PROMOCODE_SUCCESS,
    CREATE_PROMOCODE_FAILURE,
    CREATE_PROMOCODE_REQUEST,
    CREATE_PROMOCODE_RESET,
}

    from '../actions/create';




const setCreatePromoCode = (state = { created: false }, action) => {
    switch (action.type) {
        case CREATE_PROMOCODE_SUCCESS:
            return Object.assign({}, action);
        case CREATE_PROMOCODE_FAILURE:
            return Object.assign({}, action);
        case CREATE_PROMOCODE_REQUEST:
            return Object.assign({}, action);
        case CREATE_PROMOCODE_RESET:
            return Object.assign({}, action);
        default:
            return state;
    }
};

export {
    setCreatePromoCode
}